import React, { useMemo, useState } from 'react';
import './MercadoPagoDemo.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { auth } from '../firebase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.thethingapp.com';

const readOrder = (locationState) => {
  if (locationState?.plan && locationState?.billing) return locationState;
  try {
    const raw = sessionStorage.getItem('tt_checkout_order');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

const MercadoPagoDemo = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const order = useMemo(() => readOrder(location.state), [location.state]);

  const [method, setMethod] = useState('tarjeta');
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState('approved');

  const amountLabel = order?.plan?.priceLabel || '180.000';
  const currency = order?.plan?.currency || 'ARS';
  const paymentType = order?.paymentType || 'monthly';

  const handlePay = async () => {
    setProcessing(true);
    await new Promise((r) => setTimeout(r, 900));

    if (result === 'approved') {
      try {
        const user = auth.currentUser;
        if (user?.uid) {
          await fetch(`${BACKEND_URL}/api/demo-payment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              userId: user.uid,
              months: 1,
              paymentType,
              billing: order?.billing || null,
            }),
          }).then(async (r) => {
            const data = await r.json().catch(() => ({}));
            if (!data?.success) {
              throw new Error(data?.error || 'demo-payment failed');
            }
          });
        }

        toast.success('✅ Pago aprobado (demo).');
      } catch (err) {
        console.error('[mp-demo] Error demo-payment:', err);
        toast.error('❌ No se pudo confirmar el pago demo en el servidor.');
      }
    } else if (result === 'pending') {
      toast.info('⏳ Pago pendiente (demo).');
    } else {
      toast.error('❌ Pago rechazado (demo).');
    }

    navigate(`/subscription?status=${encodeURIComponent(result)}&payment=${encodeURIComponent(paymentType)}`);
  };

  return (
    <div className="mp-demo-page">
      <div className="mp-demo-card">
        <div className="mp-demo-header">
          <p className="mp-demo-badge">MERCADOPAGO</p>
          <h1 className="mp-demo-title">Pasarela de pago (Demo)</h1>
          <p className="mp-demo-subtitle">Esto es una simulación para probar el flujo y el diseño.</p>
        </div>

        <div className="mp-demo-grid">
          <div className="mp-demo-section">
            <h2 className="mp-demo-section-title">Elegí tu medio de pago</h2>

            <div className="mp-demo-methods">
              <label className={`mp-demo-method ${method === 'tarjeta' ? 'selected' : ''}`}>
                <input type="radio" name="method" checked={method === 'tarjeta'} onChange={() => setMethod('tarjeta')} />
                <div>
                  <p className="mp-demo-method-title">Tarjeta</p>
                  <p className="mp-demo-method-desc">Crédito o débito</p>
                </div>
              </label>

              <label className={`mp-demo-method ${method === 'transferencia' ? 'selected' : ''}`}>
                <input type="radio" name="method" checked={method === 'transferencia'} onChange={() => setMethod('transferencia')} />
                <div>
                  <p className="mp-demo-method-title">Transferencia</p>
                  <p className="mp-demo-method-desc">CBU / CVU</p>
                </div>
              </label>

              <label className={`mp-demo-method ${method === 'dinero' ? 'selected' : ''}`}>
                <input type="radio" name="method" checked={method === 'dinero'} onChange={() => setMethod('dinero')} />
                <div>
                  <p className="mp-demo-method-title">Dinero en cuenta</p>
                  <p className="mp-demo-method-desc">Saldo de MercadoPago</p>
                </div>
              </label>
            </div>

            <div className="mp-demo-result">
              <p className="mp-demo-result-title">Resultado (demo)</p>
              <select value={result} onChange={(e) => setResult(e.target.value)}>
                <option value="approved">Aprobado</option>
                <option value="pending">Pendiente</option>
                <option value="rejected">Rechazado</option>
              </select>
            </div>
          </div>

          <div className="mp-demo-section">
            <h2 className="mp-demo-section-title">Resumen</h2>

            <div className="mp-demo-summary">
              <div className="mp-demo-summary-row">
                <span>Suscripción</span>
                <span>{currency} {amountLabel}</span>
              </div>
              <div className="mp-demo-summary-row mp-demo-summary-total">
                <span>Total</span>
                <span>{currency} {amountLabel}</span>
              </div>
            </div>

            <button
              className="mp-demo-pay"
              onClick={handlePay}
              disabled={processing}
            >
              {processing ? <span className="mp-demo-spinner" /> : 'Pagar (Demo)'}
            </button>

            <button
              className="mp-demo-back"
              onClick={() => navigate('/checkout')}
              disabled={processing}
            >
              Volver al checkout
            </button>

            <p className="mp-demo-note">
              Cuando configures credenciales reales, este paso será el checkout real de MercadoPago.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MercadoPagoDemo;
